import type { ReactNode } from "react";
import React, { useState } from "react";
import { AccordionItem, type AccordionItemType } from "./AccordionItem";
import { AccordionItemContent } from "./AccordionItemContent";
import { AccordionItemFooter } from "./AccordionItemFooter";
import { AccordionItemLabel } from "./AccordionItemLabel";

export type AccordionProps = {
  children: ReactNode;
  selectedValue?: string | null; // For controlled state
  onChange?: (value: string) => void; // For controlled state
  expandAll?: boolean;
  radioName: string;
};
type AccordionType = React.FC<AccordionProps> & {
  Item: AccordionItemType;
};
export const Accordion: AccordionType = ({
  children,
  selectedValue: controlledSelectedValue,
  onChange: onControlledChange,
  expandAll = false,
  radioName
}) => {
  const [uncontrolledSelectedValue, setUncontrolledSelectedValue] = useState<
    string | null
  >(null);

  const isControlled = controlledSelectedValue !== undefined;
  const selectedValue = isControlled
    ? controlledSelectedValue
    : uncontrolledSelectedValue;

  const handleChange = (value: string) => {
    if (!isControlled) {
      setUncontrolledSelectedValue(value);
    }
    onControlledChange?.(value);
  };

  return (
    <div role="tablist" aria-label="Accordion Options">
      {React.Children.map(children, (child) =>
        React.cloneElement(child as React.ReactElement, {
          selectedValue,
          onChange: handleChange,
          expandAll,
          radioName
        })
      )}
    </div>
  );
};

Accordion.Item = Object.assign(AccordionItem, {
  Content: AccordionItemContent,
  Footer: AccordionItemFooter,
  Label: AccordionItemLabel
});
